
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 1.667a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zM.833 5a4.167 4.167 0 118.334 0A4.167 4.167 0 01.833 5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.583 2.917c.23 0 .417.186.417.416V5h1.667a.417.417 0 010 .833H4.583a.417.417 0 01-.416-.416V3.333c0-.23.186-.416.416-.416z"}})])
          )
        }
      }
    